/*
 * Author Nirjhor
 * Title: Center Stock Reconcile
 * Description: Center Stock Reconcile
 * Date: 13/08/2026
 */

import { useAuth } from '../../contexts/AuthContext';
import { CenterStockReconcileProvider } from '../centerWarehouse/stockReconcile/ContextAPI';
import Index from '../centerWarehouse/stockReconcile/Index';
import PermissionDenied from './PermissionDenied';

export default function CenterStockReconcile() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['center-stock-reconcile']) return <PermissionDenied />;

    return (
        <CenterStockReconcileProvider>
            <Index />
        </CenterStockReconcileProvider>
    );
}
